import { bsh_getAdminUserDetails } from "./sf_browser_storage_helper";

/**
 * Request interceptor to add admin access token on each
 * request if present
 * @returns 
 */
export const sf_fetch = async (resource, options = {}) => {
  const extra_headers = (['staging', 'production'].includes(process.env.NODE_ENV)) ? {} : {
    'ngrok-skip-browser-warning': true
  };

  const headers = {
    ...(options?.headers || {}),
    ...extra_headers,
    'admin-token': bsh_getAdminUserDetails().token || '',
  }

  const headers_with_dashes = Object.entries(headers).reduce((accum, [k, v]) => ({
    ...accum,
    [k.replace('_', '-')]: v
  }), {})

  let forward_opts = {
    ...(options || {}),
    headers: headers_with_dashes
  }

  return await fetch(resource, forward_opts);
}
